<template>
<div class="dynamic-list">
    <div class="item" v-for="(item, key, index) in data" :key="index">
        <span class="label" :title="item[labelField]">{{ item[labelField] }}</span>
        <span class="delete-icon" @click="onDelete(item[keyField])"><i class="material-icons">close</i></span>
    </div>

    <div class="item new-item">
        <span><form @submit.prevent="onAdd()"><input class="new-item-input" type="text" v-model="new_item" /></form></span>
        <span class="add-icon" @click="onAdd()"><i class="material-icons">add</i></span>
    </div>
</div>
</template>

<script>
export default {
    name: "dynamic-list",

    props: ["data", "keyField", "labelField"],

    data () {
        return {
            new_item: ""
        }
    },

    methods: {
        onAdd: function () {
            this.$emit("add", this.new_item)

            this.new_item = ""
        },

        onDelete: function (itemKey) {
            this.$emit("delete", itemKey)
        }
    }
}
</script>

<style>
.dynamic-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: -15px;
}

.dynamic-list .item {
    align-items: center;
    background: #fbfbfb;
    border: 1px solid #b7b7b7;
    display: flex;
    flex: 0 0 calc(25% - 12px);
    justify-content: space-between;
    line-height: 1;
    margin-bottom: 15px;
    padding: 8px;
    width: calc(25% - 12px);
}

.dynamic-list .item .label {
    overflow: hidden;
    padding-right: 3px;
    text-overflow: ellipsis;
}

.dynamic-list .item .delete-icon {
    cursor: pointer;
}

.dynamic-list .item + .item {
    margin-left: 15px;
}

.dynamic-list .item:nth-child(4n+1) {
    margin-left: 0;
}

.dynamic-list .item.new-item {
    background: #fff;
}

.dynamic-list .new-item-input {
    box-shadow: none;
    border: 0;
    border-bottom: 1px solid #b7b7b7;
    padding: 0 0 2px;
    outline: 0;
    width: calc(100% - 15px);
}
</style>



// WEBPACK FOOTER //
// src/components/DynamicList.vue